import script from "./hold_days.vue?vue&type=script&setup=true&lang=js"
export * from "./hold_days.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__